<template>
    <el-drawer
        title="手动保存 POIID"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
        append-to-body
    >
        <div class="drawer-content" v-loading="dataLoading">
			<div class="MB20">				 
				<p>这个功能一般用于无法正常创建 POI, 但是能在抖音找到对应 POI, 或者让抖音 BD 手动创建了 POI, 就可以直接保存POI ID.</p>
				<p class="color-danger MT15">注意，一旦提交,会覆盖掉以前已经绑定过的 POIID.</p>
			</div>
            <el-form
                :model="formData"                
                ref="formData"
                label-position="top"
            >
                
                <el-form-item prop="poiId" label="抖音POI ID:">
                    <el-input v-model="formData.poiId" placeholder="请输入抖音POI ID" size="medium" maxlength="40"></el-input>
                </el-form-item>
				
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >提交</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
export default {
    props:{
        userId:{
            type:[Number,String],
            default:''
        },
    },
    components:{},
    data(){
        return{
            drawerShow: false,
            dataLoading: false,
            btnLoading:false,              
            id:'',
			formData:{},
        }
    },
   
    methods:{      
        close() {           
			this.drawerShow = false;
			this.formData = {}
            this.$refs['formData'].clearValidate();           
        },
        show() {
            this.id = this.userId;           
            this.drawerShow = true;
        },        
        // 表单提交
        submitForm() {
            let self = this;
            self.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.submitAction()                    
                } else {
                    return false;
                }
            });
        },
        submitAction(){			
			const _url = "/site/savePoiId";
            this.btnLoading = true;
            this.$request({
                url: _url,
                params: {
                    id:this.id,
					poiId:this.formData.poiId
                },
                method: "post",
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1) {
                        this.$message.success("操作成功");
                        this.close();
						this.$emit('onUpdate');
                    } else {
                        this.$message.error(msg || "操作失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.btnLoading = false;
                });   
        }
    }
}
</script>

<style lang="scss" scoped>
.preview-box{
    text-align: center;
    .el-image{
        max-width: 100%;
    }
}
.upload-btn {
    height: 36px;
    line-height: 36px;
    border-radius: 4px;
    text-align: center;
    position: relative;
    background: $--color-theme;
    overflow: hidden;
    .upload-bar{
        ::v-deep .el-upload{
            width: 100%;
        }
    }
    .el-button {
        width: 100%;
        background: none;
        border: 0;
    }
    .progress-bar {
        display: block;
        height: 100%;
        color: #ffffff;
        span {
            position: absolute;
            height: 100%;
            width: 100%;
            left: 0;
            top: 0;
        }
        .progress {
            height: 100%;
            background: #67c23a;
            transition: width 0.6s ease-out;
        }
    }
}
</style>